import rightImg from "images/about-hero-right.png";
import { FC } from "react";
import { Helmet } from "react-helmet";
import SectionAbout from "./SectionAbout";
import { useData } from "data/data-provider";
import BgGlassmorphism from "designs/DesignA/components/BgGlassmorphism/BgGlassmorphism";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const { aboutUs, companyDetails } = useData();

  // Page title — pulls a sensible default from the FMS-managed about-us
  // section heading (stripped of any HTML tags Quill may have added) before
  // falling back to the SEO title or the literal "About Us". Keeps the
  // page top free of hardcoded copy.
  const stripHtml = (html?: string | null) =>
    (html || "").replace(/<[^>]+>/g, "").trim();
  const pageTitle =
    stripHtml(aboutUs?.heading) ||
    companyDetails?.seo_title?.trim() ||
    `About ${companyDetails?.company_name || ""}`.trim() ||
    "About Us";

  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <h1 className="text-7xl font-semibold text-text-color mt-6 w-full text-center">
        {pageTitle}
      </h1>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-12 lg:py-20 space-y-16 lg:space-y-28">
        {aboutUs && <SectionAbout aboutUs={aboutUs} />}
      </div>
    </div>
  );
};

export default PageAbout;
